import { default as Errors } from './Errors'

class Form {

    constructor(data) {
        this.mapData(data);
        this.isRequesting = false;
        this.submitKeys = [];
        this.errors = new Errors();
    }

    mapData(data) {
        const { originalData, ...props  } = data;
        this.originalData = { ...props };
        this.resetData();
    }

    reset() {
        this.resetData();
        // this.clearErrors();
    }

    save() {
        for (const key in this.originalData) {
            if (key === "originalData" || key === "isRequesting") {
                return;
            }
            if (this[key] instanceof Form) {
                this[key].save();
    
            } else if (Array.isArray(this[key])) {
                this.originalData[key] = [...this[key]];
    
            } else if (typeof this[key] === "object" && this[key] != null) {
                this.originalData[key] = {...this[key]};
    
            } else {
                this.originalData[key] = this[key];
    
            }
        }
    }

    resetData() {
        for (const key in this.originalData) {
            if (key === "originalData" || key === "isRequesting") {
                return;
            }
            if (this.originalData[key] instanceof Form) {
                this[key].resetData();
    
            } else if (Array.isArray(this.originalData[key])) {
                this[key] = [...this.originalData[key]];
    
            } else if (typeof this.originalData[key] === "object" && this.originalData[key] != null) {
                this[key] = {...this.originalData[key]};
    
            } else {
                this[key] = this.originalData[key];
    
            }
        }
    }

    setSubmitKeys(keys) {
        this.submitKeys = Array.isArray(keys) ? keys : [ keys ];
    }

    clearErrors() {
        this.errors.clear();
    }

    getData() {
        let data = {};
        let keys = this.submitKeys.length > 0
            ? this.submitKeys
            : Object.keys(this.originalData);

        keys.forEach(key => data[key] = this[key]);

        return data;
    }

}

export default Form
export { Form }